import type { FC } from 'react';

import { addPleaseSelectOption, ControlledSelect } from '@components/Form';
import type { ControlledSelectProps } from '@components/Form';
import { useMdmGroupSelect } from '@hooks/useMdmGroupSelect';

import type { EditScanDeviceFormValues } from './EditScanDeviceFooter';

export type ControlledMdmGroupSelectProps = Omit<
  ControlledSelectProps<EditScanDeviceFormValues>,
  'options'
>;

export const ControlledMdmGroupSelect: FC<ControlledMdmGroupSelectProps> = ({
  textFieldProps,
  ...props
}) => {
  const { options } = useMdmGroupSelect(addPleaseSelectOption);

  return (
    <ControlledSelect
      {...props}
      options={options}
      textFieldProps={{
        ...textFieldProps,
        size: 'small',
        sx: { minWidth: (theme) => theme.spacing(22.5) },
      }}
    />
  );
};
